// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { QtyFieldStyles } from "@awc/App/Components/Qty/QtyField";
import ProductQuantityOrdered from "@awc/Overrides/Components/ProductQuantityOrdered";
import { mergeWithCss } from "@awc/XDL/Utilities";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";

/**
 * XNG-Changes:
 * Add extra props
 */
interface OwnProps {
    labelOverride?: string;
    extendedStyles?: ProductDetailsQuantityOrderedStyles;
}

type Props = OwnProps & WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsQuantityOrderedStyles {
    quantityOrdered?: QtyFieldStyles;
}

export const quantityOrderedStyles: ProductDetailsQuantityOrderedStyles = {};

// const styles = quantityOrderedStyles;

const ProductDetailsQuantityOrdered = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    extendedStyles,
    /**
     * XNG-Changes
     */
    labelOverride,
}: Props) => {
    const [styles] = useState(() => mergeWithCss(quantityOrderedStyles, extendedStyles));

    return (
        <ProductQuantityOrdered
            configurationSelection={configurationSelection}
            configurationCompleted={configurationCompleted}
            variantSelectionCompleted={variantSelectionCompleted}
            extendedStyles={styles.quantityOrdered}
            /**
             * XNG-Changes
             */
            labelOverride={labelOverride ?? ""}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsQuantityOrdered)),
    definition: {
        displayName: "Quantity Ordered",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
